import React from 'react'
import StandardVideo from './StandardVideo'
import AmbientVideo from './AmbientVideo'

export const SoundlessVideo = ({ width, height, config, imageProps, ...rest }) => {
  const aspectRatio = width && height && `${width}:${height}`
  return <StandardVideo aspectRatio={aspectRatio} soundless item={rest} config={config} {...imageProps} />
}

const BlockVideo = ({ ynapParameter, config, pictures, isMobile, video, allowMute, imageProps, isPictureFullWidth }) => {
  if (!ynapParameter) return <SoundlessVideo {...video} config={config} {...imageProps} />
  const { account, player } = config && config?.brightcove
  const playerId = player.soundless
  const { desktopVideoId, mobileVideoId } = JSON.parse(ynapParameter)
  const videoId = isMobile ? mobileVideoId : desktopVideoId
  return (
    <AmbientVideo
      account={account}
      playerId={playerId}
      videoId={videoId}
      pictures={pictures}
      imageSphere={config.imageSphere}
      allowMute={allowMute}
      {...imageProps}
      isPictureFullWidth={isPictureFullWidth}
    />
  )
}

export default BlockVideo
